import { render, staticRenderFns } from "./MobileLogin.vue?vue&type=template&id=55963ab4&scoped=true&"
import script from "./MobileLogin.vue?vue&type=script&lang=js&"
export * from "./MobileLogin.vue?vue&type=script&lang=js&"
import style0 from "./MobileLogin.vue?vue&type=style&index=0&id=55963ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55963ab4",
  null
  
)

export default component.exports